import { createContext } from "react";
import benefitPlansContextInterface from "./types";

const BenefitPlansContext = createContext<benefitPlansContextInterface>({
  benefitPlans: [],
  setBenefitPlans: () => {},
  isLoading: true,
  setIsLoading: () => {},
});

export default BenefitPlansContext;
